import api from '@/api/client';
import { notify } from '@/core/toast/notify';
import {
  isPublicStoredAssetPath,
  normalizeStoredPath,
  resolveFileContentRequestPath,
} from '@/utils/fileUrl';

/**
 * Fetches a stored file with the session client and opens it in a new tab for inline viewing.
 */
export async function openStoredFileInNewTab(storedPath: string | undefined | null): Promise<void> {
  const trimmed = storedPath?.trim();
  if (!trimmed) {
    notify.error('Document is not available.');
    return;
  }

  const popup = window.open('', '_blank', 'noopener,noreferrer');
  if (!popup) {
    notify.error('Allow pop-ups to view this document.');
    return;
  }

  try {
    let blob: Blob;
    const authPath = resolveFileContentRequestPath(trimmed, 'inline');
    if (authPath && !isPublicStoredAssetPath(trimmed)) {
      const response = await api.get(authPath, { responseType: 'blob' });
      blob = response.data as Blob;
    } else {
      const staticPath = normalizeStoredPath(trimmed);
      if (!staticPath) {
        throw new Error('unavailable');
      }
      const response = await api.get(staticPath, { responseType: 'blob' });
      blob = response.data as Blob;
    }

    const blobUrl = URL.createObjectURL(blob);
    popup.location.replace(blobUrl);
    window.setTimeout(() => URL.revokeObjectURL(blobUrl), 120_000);
  } catch {
    popup.close();
    notify.error('Could not open document. Try again or download the file.');
  }
}
